import React from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation } from "react-router-dom";

// img
import logo from "../../../Assets/images/logo.png";
import { Accordion, Button } from "react-bootstrap";

const Sidebar = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const pageActive = location.pathname;
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  return (
    <div
      className={`${styles.sidebar} ${
        sidebar && styles.active
      } pt-4 position-fixed`}
    >
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="white"
          />
        </svg>
      </Button>
      <div className={`${styles.top} top text-center px-3 py-2`}>
        <Link to="/" className={`${styles.logo} logo`}>
          <img src={logo} alt="" className="img-fluid" />
        </Link>
      </div>
      <Accordion className={`${styles.linkWrpper} linkWrpper ps-2 pt-4`}>
        <ul className="list-unstyled ps-0 mb-0">
          <li className="">
            <NavLink
              to="/dashboard"
              className={`${styles.link} ${
                pageActive.includes("/dashboard") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M2.5 0H9.14551C10.5273 0 11.6455 1.11816 11.6455 2.5V5.93262C11.6455 7.31445 10.5273 8.43262 9.14551 8.43262H2.5C1.11816 8.43262 0 7.31445 0 5.93262V2.5C0 1.11816 1.11816 0 2.5 0Z"
                    fill="white"
                  />
                  <path
                    d="M2.5 10.2295H9.14551C10.5273 10.2295 11.6455 11.3477 11.6455 12.7295V22.5C11.6455 23.8818 10.5273 25 9.14551 25H2.5C1.11816 25 0 23.8818 0 22.5V12.7295C0 11.3477 1.11816 10.2295 2.5 10.2295Z"
                    fill="white"
                  />
                  <path
                    d="M15.8545 16.5674H22.5C23.8818 16.5674 25 17.6855 25 19.0674V22.5C25 23.8818 23.8818 25 22.5 25H15.8545C14.4727 25 13.3545 23.8818 13.3545 22.5V19.0674C13.3545 17.6855 14.4727 16.5674 15.8545 16.5674Z"
                    fill="white"
                  />
                  <path
                    d="M15.8545 0H22.5C23.8818 0 25 1.11816 25 2.5V12.2705C25 13.6523 23.8818 14.7705 22.5 14.7705H15.8545C14.4727 14.7705 13.3545 13.6523 13.3545 12.2705V2.5C13.3545 1.11816 14.4727 0 15.8545 0Z"
                    fill="white"
                  />
                </svg>
              </span>
              Dashboard
            </NavLink>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="3"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10 border-top px-0`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M22.0002 6.16C22.0002 7.83842 21.329 9.36008 20.2402 10.4711C19.1221 11.6121 17.5638 12.32 15.8402 12.32C12.4381 12.32 9.68018 9.56208 9.68018 6.16C9.68018 5.30948 9.85255 4.49922 10.1643 3.76224L10.1737 3.74C11.1141 1.54092 13.2972 0 15.8402 0C19.2423 0 22.0002 2.75792 22.0002 6.16ZM15.8402 3.74C15.2327 3.74 14.7402 4.23249 14.7402 4.84C14.7402 5.08301 14.5432 5.28 14.3002 5.28C14.0572 5.28 13.8602 5.08301 13.8602 4.84C13.8602 3.74647 14.7466 2.86 15.8402 2.86C16.9337 2.86 17.8202 3.74647 17.8202 4.84C17.8202 5.7823 17.1619 6.57085 16.2802 6.77094V7.15C16.2802 7.39301 16.0832 7.59 15.8402 7.59C15.5972 7.59 15.4002 7.39301 15.4002 7.15V6.6C15.4002 6.52516 15.4002 6.45484 15.4002 6.38C15.4002 6.13699 15.5972 5.94 15.8402 5.94C16.4477 5.94 16.9402 5.44751 16.9402 4.84C16.9402 4.23249 16.4477 3.74 15.8402 3.74ZM15.8402 10.01C16.3262 10.01 16.7202 9.616 16.7202 9.13C16.7202 8.644 16.3262 8.25 15.8402 8.25C15.3542 8.25 14.9602 8.644 14.9602 9.13C14.9602 9.616 15.3542 10.01 15.8402 10.01Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.22698 3.73999H4.4C1.96995 3.73999 0 5.70994 0 8.13999V15.18C0 17.61 1.96995 19.58 4.4 19.58H6.9931C7.10978 19.58 7.2217 19.6263 7.30422 19.7089L9.20682 21.6115C9.63642 22.0411 10.3329 22.0411 10.7625 21.6115L12.6651 19.7089C12.7476 19.6263 12.8595 19.58 12.9762 19.58H15.84C18.2701 19.58 20.24 17.61 20.24 15.18V11.6559C19.0348 12.6221 17.5049 13.2 15.84 13.2C11.9519 13.2 8.8 10.0481 8.8 6.15999C8.8 5.30969 8.95074 4.49461 9.22698 3.73999ZM3.3 8.35999C3.3 8.11698 3.49699 7.91999 3.74 7.91999H6.82C7.06301 7.91999 7.26 8.11698 7.26 8.35999C7.26 8.603 7.06301 8.79999 6.82 8.79999H3.74C3.49699 8.79999 3.3 8.603 3.3 8.35999ZM3.3 15.4C3.3 15.157 3.49699 14.96 3.74 14.96H14.3C14.543 14.96 14.74 15.157 14.74 15.4C14.74 15.643 14.543 15.84 14.3 15.84H3.74C3.49699 15.84 3.3 15.643 3.3 15.4ZM3.74 11.44C3.49699 11.44 3.3 11.637 3.3 11.88C3.3 12.123 3.49699 12.32 3.74 12.32H8.36C8.60301 12.32 8.8 12.123 8.8 11.88C8.8 11.637 8.60301 11.44 8.36 11.44H3.74Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Deliveries
              </Accordion.Header>
              <Accordion.Body className="pt-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/booking/booking-request"
                      className={`
                      ${styles.link} ${
                        pageActive.includes("/booking-request") && styles.active
                      } 
                      text-white px-2 py-1`}
                    >
                      Delivery Request
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/booking/my-bookings"
                      className={`${styles.link} ${
                        pageActive.includes("/my-bookings") && styles.active
                      } text-white px-2 py-1`}
                    >
                      My Deliveries
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          {/* <li className="">
            <NavLink
              to="/booking-request"
              className={`${styles.link} ${
                pageActive.includes("/booking-request") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.0002 6.16C22.0002 7.83842 21.329 9.36008 20.2402 10.4711C19.1221 11.6121 17.5638 12.32 15.8402 12.32C12.4381 12.32 9.68018 9.56208 9.68018 6.16C9.68018 5.30948 9.85255 4.49922 10.1643 3.76224L10.1737 3.74C11.1141 1.54092 13.2972 0 15.8402 0C19.2423 0 22.0002 2.75792 22.0002 6.16ZM15.8402 3.74C15.2327 3.74 14.7402 4.23249 14.7402 4.84C14.7402 5.08301 14.5432 5.28 14.3002 5.28C14.0572 5.28 13.8602 5.08301 13.8602 4.84C13.8602 3.74647 14.7466 2.86 15.8402 2.86C16.9337 2.86 17.8202 3.74647 17.8202 4.84C17.8202 5.7823 17.1619 6.57085 16.2802 6.77094V7.15C16.2802 7.39301 16.0832 7.59 15.8402 7.59C15.5972 7.59 15.4002 7.39301 15.4002 7.15V6.6C15.4002 6.52516 15.4002 6.45484 15.4002 6.38C15.4002 6.13699 15.5972 5.94 15.8402 5.94C16.4477 5.94 16.9402 5.44751 16.9402 4.84C16.9402 4.23249 16.4477 3.74 15.8402 3.74ZM15.8402 10.01C16.3262 10.01 16.7202 9.616 16.7202 9.13C16.7202 8.644 16.3262 8.25 15.8402 8.25C15.3542 8.25 14.9602 8.644 14.9602 9.13C14.9602 9.616 15.3542 10.01 15.8402 10.01Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.22698 3.73999H4.4C1.96995 3.73999 0 5.70994 0 8.13999V15.18C0 17.61 1.96995 19.58 4.4 19.58H6.9931C7.10978 19.58 7.2217 19.6263 7.30422 19.7089L9.20682 21.6115C9.63642 22.0411 10.3329 22.0411 10.7625 21.6115L12.6651 19.7089C12.7476 19.6263 12.8595 19.58 12.9762 19.58H15.84C18.2701 19.58 20.24 17.61 20.24 15.18V11.6559C19.0348 12.6221 17.5049 13.2 15.84 13.2C11.9519 13.2 8.8 10.0481 8.8 6.15999C8.8 5.30969 8.95074 4.49461 9.22698 3.73999ZM3.3 8.35999C3.3 8.11698 3.49699 7.91999 3.74 7.91999H6.82C7.06301 7.91999 7.26 8.11698 7.26 8.35999C7.26 8.603 7.06301 8.79999 6.82 8.79999H3.74C3.49699 8.79999 3.3 8.603 3.3 8.35999ZM3.3 15.4C3.3 15.157 3.49699 14.96 3.74 14.96H14.3C14.543 14.96 14.74 15.157 14.74 15.4C14.74 15.643 14.543 15.84 14.3 15.84H3.74C3.49699 15.84 3.3 15.643 3.3 15.4ZM3.74 11.44C3.49699 11.44 3.3 11.637 3.3 11.88C3.3 12.123 3.49699 12.32 3.74 12.32H8.36C8.60301 12.32 8.8 12.123 8.8 11.88C8.8 11.637 8.60301 11.44 8.36 11.44H3.74Z"
                    fill="white"
                  />
                </svg>
              </span>
              Booking Request
            </NavLink>
          </li> */}


          {/**Manage Service */}
          {/* <li className="">
            <NavLink
              to="/manage-service"
              className={`${styles.link} ${
                pageActive.includes("/manage-service") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 22 21"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.7184 2.40996C17.3006 2.54852 17.8568 2.77938 18.3664 3.0932L19.4374 2.61759L20.6996 3.87974L20.2241 4.95037C20.538 5.46012 20.7688 6.01645 20.9074 6.5989L22 7.01937V8.8044L20.9072 9.22506C20.7686 9.80737 20.5377 10.3635 20.2239 10.8731L20.6995 11.9441L19.4373 13.2063L18.3667 12.7308C17.857 13.0447 17.3007 13.2755 16.7183 13.4141L16.2977 14.5068H14.5127L14.0921 13.4139C13.5097 13.2753 12.9536 13.0445 12.444 12.7307L11.373 13.2063L10.1108 11.9441L10.5864 10.8735C10.2724 10.3637 10.0416 9.80737 9.90298 9.22501L8.81036 8.80444V7.01947L9.90312 6.59885C10.0417 6.01654 10.2725 5.46031 10.5864 4.95064L10.1108 3.87979L11.373 2.61759L12.444 3.0932C12.9536 2.77938 13.5098 2.54852 14.0921 2.40996L14.5128 1.31711H16.2977L16.7184 2.40996ZM3.05465 13.0264L4.65575 19.2139C4.73316 19.513 4.55171 19.8212 4.25255 19.8986L3.06144 20.2068C2.76224 20.2842 2.45415 20.1028 2.37673 19.8036L0.775592 13.6162C0.698179 13.317 0.879633 13.0089 1.17879 12.9315L2.3699 12.6233C2.6691 12.5458 2.97724 12.7273 3.05465 13.0264ZM2.14161 13.6449C1.93192 13.6204 1.74203 13.7705 1.71742 13.9802C1.69285 14.1899 1.84291 14.3798 2.0526 14.4044C2.26229 14.4289 2.45222 14.2789 2.47679 14.0691C2.50135 13.8594 2.3513 13.6695 2.14161 13.6449ZM5.7854 17.6258L10.2753 20.218C10.8331 20.5401 11.4299 20.6205 12.0489 20.4358L19.8422 18.1091C20.2237 17.9953 20.4102 17.4547 20.3001 17.0905C20.0542 16.2773 18.6792 16.5478 18.1071 16.7034L13.8456 17.8627C12.8656 18.1292 12.2489 17.855 11.4417 17.4916C11.429 17.4859 11.4169 17.4795 11.4052 17.4726C10.6269 17.0816 9.89775 16.6095 9.14467 16.1748C8.96986 16.0743 8.90959 15.8511 9.01001 15.6763C9.11048 15.5015 9.33364 15.4412 9.50845 15.5417C9.78716 15.7025 10.0209 15.8427 10.2512 15.9808C10.7467 16.2778 11.2269 16.5656 11.7299 16.8185C12.1138 16.9739 12.4743 16.9393 12.6951 16.5569C12.698 16.5518 12.7011 16.5468 12.7043 16.5419C12.8882 16.2024 12.7449 15.7987 12.4381 15.5871C11.3824 15.0867 10.4109 14.4095 9.64705 13.8771C9.37195 13.6854 9.12326 13.5121 8.93979 13.393C8.30344 12.9802 7.55828 13.1099 6.86913 13.2955L4.07637 14.0475L5.0232 17.7065C5.2453 17.647 5.58429 17.4972 5.7854 17.6258ZM5.06935 1.63428C5.44262 1.7231 5.79911 1.8711 6.12581 2.07226L6.81235 1.76738L7.62149 2.57647L7.31665 3.26278C7.5179 3.58957 7.6659 3.94616 7.75472 4.31956L8.45515 4.58915V5.73343L7.75459 6.00307C7.66576 6.37633 7.51777 6.73282 7.3166 7.05952L7.62149 7.74606L6.81239 8.5552L6.12608 8.25037C5.79929 8.45162 5.44266 8.59962 5.0693 8.68844L4.79971 9.38887H3.65544L3.3858 8.6883C3.01253 8.59948 2.65604 8.45148 2.32934 8.25037L1.6428 8.55525L0.833663 7.74615L1.1385 7.05984C0.937246 6.73305 0.789296 6.37642 0.700425 6.00307L0 5.73343V4.58915L0.700517 4.31952C0.789342 3.9462 0.937338 3.58967 1.13855 3.26297L0.833663 2.57652L1.64276 1.76738L2.32925 2.07226C2.65595 1.8711 3.01249 1.7231 3.38571 1.63428L3.65539 0.933716H4.79967L5.06935 1.63428ZM4.22753 3.16571C3.12533 3.16571 2.23199 4.05904 2.23199 5.16129C2.23199 6.26349 3.12533 7.15683 4.22753 7.15683C5.32977 7.15683 6.22311 6.26349 6.22311 5.16129C6.22316 4.05904 5.32977 3.16571 4.22753 3.16571ZM15.4052 4.50377C13.5229 4.50377 11.9971 6.02965 11.9971 7.91189C11.9971 9.79412 13.5229 11.32 15.4052 11.32C17.2874 11.32 18.8133 9.79412 18.8133 7.91189C18.8133 6.02965 17.2875 4.50377 15.4052 4.50377Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Service
            </NavLink>
          </li> */}


          {/* <li className="">
            <NavLink
              to="/manage-booking"
              className={`${styles.link} ${
                pageActive.includes("/manage-booking") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 25"
                  fill="none"
                >
                  <path
                    d="M0 23.6604C0 24.4001 0.59967 24.9998 1.33926 24.9998H13.8393C14.579 24.9998 15.1784 24.4001 15.1784 23.6604V22.3213H0V23.6604ZM11.6071 23.2142H12.5C12.7466 23.2142 12.9465 23.4141 12.9465 23.6604C12.9465 23.9071 12.7466 24.107 12.5 24.107H11.6071C11.3605 24.107 11.1606 23.9071 11.1606 23.6604C11.1606 23.4141 11.3605 23.2142 11.6071 23.2142ZM7.14279 23.2142H8.03558C8.28217 23.2142 8.48206 23.4141 8.48206 23.6604C8.48206 23.9071 8.28217 24.107 8.03558 24.107H7.14279C6.89621 24.107 6.69647 23.9071 6.69647 23.6604C6.69647 23.4141 6.89621 23.2142 7.14279 23.2142ZM2.67838 23.2142H3.57147C3.8179 23.2142 4.01779 23.4141 4.01779 23.6604C4.01779 23.9071 3.8179 24.107 3.57147 24.107H2.67838C2.43195 24.107 2.23206 23.9071 2.23206 23.6604C2.23206 23.4141 2.43195 23.2142 2.67838 23.2142Z"
                    fill="white"
                  />
                  <path
                    d="M11.6071 8.92874C11.6071 8.68231 11.4072 8.48242 11.1606 8.48242H10.2678C10.2678 8.729 10.0679 8.92874 9.82147 8.92874C9.57489 8.92874 9.375 8.729 9.375 8.48242H5.80338C5.80338 8.729 5.60379 8.92874 5.35706 8.92874C5.11047 8.92874 4.91058 8.729 4.91058 8.48242H4.01779C3.77121 8.48242 3.57147 8.68231 3.57147 8.92874V9.82169H11.6071V8.92874Z"
                    fill="white"
                  />
                  <path
                    d="M4.01779 16.5182H11.1606C11.4072 16.5182 11.6071 16.3183 11.6071 16.0719V10.7148H3.57147V16.0719C3.57147 16.3183 3.77121 16.5182 4.01779 16.5182ZM5.0415 13.9706C5.21576 13.7962 5.4985 13.7962 5.67276 13.9706L6.25 14.5479L9.50577 11.2919C9.68094 11.1227 9.95941 11.1253 10.1315 11.2974C10.3038 11.4695 10.3061 11.748 10.1369 11.9233L6.56555 15.4945C6.3913 15.6689 6.10855 15.6689 5.9343 15.4945L5.0415 14.6017C4.8671 14.4275 4.8671 14.1447 5.0415 13.9706Z"
                    fill="white"
                  />
                  <path
                    d="M0 21.4285H15.1784V3.125H0V21.4285ZM11.1606 20.5356H5.80338C5.55695 20.5356 5.35706 20.3357 5.35706 20.0894C5.35706 19.8427 5.55695 19.6428 5.80338 19.6428H11.1606C11.4072 19.6428 11.6071 19.8427 11.6071 20.0894C11.6071 20.3357 11.4072 20.5356 11.1606 20.5356ZM12.9465 19.6428H13.8393C14.0857 19.6428 14.2856 19.8427 14.2856 20.0894C14.2856 20.3357 14.0857 20.5356 13.8393 20.5356H12.9465C12.6999 20.5356 12.5 20.3357 12.5 20.0894C12.5 19.8427 12.6999 19.6428 12.9465 19.6428ZM4.01779 4.01779H9.375C9.62158 4.01779 9.82147 4.21768 9.82147 4.46442C9.82147 4.71069 9.62158 4.91058 9.375 4.91058H4.01779C3.77121 4.91058 3.57147 4.71069 3.57147 4.46442C3.57147 4.21768 3.77121 4.01779 4.01779 4.01779ZM4.01779 7.58942H4.91058V7.14279C4.91058 6.89621 5.11047 6.69647 5.35706 6.69647C5.60379 6.69647 5.80338 6.89621 5.80338 7.14279V7.58942H9.375V7.14279C9.375 6.89621 9.57489 6.69647 9.82147 6.69647C10.0679 6.69647 10.2678 6.89621 10.2678 7.14279V7.58942H11.1606C11.9003 7.58942 12.5 8.18878 12.5 8.92853V16.0715C12.5 16.8112 11.9003 17.4106 11.1606 17.4106H4.01779C3.27805 17.4106 2.67838 16.8112 2.67838 16.0715V8.92853C2.67838 8.18878 3.27805 7.58942 4.01779 7.58942ZM1.33926 4.01779H2.23206C2.47879 4.01779 2.67838 4.21768 2.67838 4.46442C2.67838 4.71069 2.47879 4.91058 2.23206 4.91058H1.33926C1.09268 4.91058 0.892792 4.71069 0.892792 4.46442C0.892792 4.21768 1.09268 4.01779 1.33926 4.01779Z"
                    fill="white"
                  />
                  <path
                    d="M13.8393 0H8.03558V0.446472C8.03558 0.692902 7.83569 0.892792 7.58926 0.892792C7.34268 0.892792 7.14279 0.692902 7.14279 0.446472V0H1.33926C0.59967 0 0 0.59967 0 1.33942V2.23221H15.1784V1.33942C15.1784 0.59967 14.579 0 13.8393 0Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Booking
            </NavLink>
          </li> */}

          {/** Guest Booking */}
          {/* <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="4"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10 border-top px-0`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 16 25"
                    fill="none"
                  >
                    <path
                      d="M0 23.6604C0 24.4001 0.59967 24.9998 1.33926 24.9998H13.8393C14.579 24.9998 15.1784 24.4001 15.1784 23.6604V22.3213H0V23.6604ZM11.6071 23.2142H12.5C12.7466 23.2142 12.9465 23.4141 12.9465 23.6604C12.9465 23.9071 12.7466 24.107 12.5 24.107H11.6071C11.3605 24.107 11.1606 23.9071 11.1606 23.6604C11.1606 23.4141 11.3605 23.2142 11.6071 23.2142ZM7.14279 23.2142H8.03558C8.28217 23.2142 8.48206 23.4141 8.48206 23.6604C8.48206 23.9071 8.28217 24.107 8.03558 24.107H7.14279C6.89621 24.107 6.69647 23.9071 6.69647 23.6604C6.69647 23.4141 6.89621 23.2142 7.14279 23.2142ZM2.67838 23.2142H3.57147C3.8179 23.2142 4.01779 23.4141 4.01779 23.6604C4.01779 23.9071 3.8179 24.107 3.57147 24.107H2.67838C2.43195 24.107 2.23206 23.9071 2.23206 23.6604C2.23206 23.4141 2.43195 23.2142 2.67838 23.2142Z"
                      fill="white"
                    />
                    <path
                      d="M11.6071 8.92874C11.6071 8.68231 11.4072 8.48242 11.1606 8.48242H10.2678C10.2678 8.729 10.0679 8.92874 9.82147 8.92874C9.57489 8.92874 9.375 8.729 9.375 8.48242H5.80338C5.80338 8.729 5.60379 8.92874 5.35706 8.92874C5.11047 8.92874 4.91058 8.729 4.91058 8.48242H4.01779C3.77121 8.48242 3.57147 8.68231 3.57147 8.92874V9.82169H11.6071V8.92874Z"
                      fill="white"
                    />
                    <path
                      d="M4.01779 16.5182H11.1606C11.4072 16.5182 11.6071 16.3183 11.6071 16.0719V10.7148H3.57147V16.0719C3.57147 16.3183 3.77121 16.5182 4.01779 16.5182ZM5.0415 13.9706C5.21576 13.7962 5.4985 13.7962 5.67276 13.9706L6.25 14.5479L9.50577 11.2919C9.68094 11.1227 9.95941 11.1253 10.1315 11.2974C10.3038 11.4695 10.3061 11.748 10.1369 11.9233L6.56555 15.4945C6.3913 15.6689 6.10855 15.6689 5.9343 15.4945L5.0415 14.6017C4.8671 14.4275 4.8671 14.1447 5.0415 13.9706Z"
                      fill="white"
                    />
                    <path
                      d="M0 21.4285H15.1784V3.125H0V21.4285ZM11.1606 20.5356H5.80338C5.55695 20.5356 5.35706 20.3357 5.35706 20.0894C5.35706 19.8427 5.55695 19.6428 5.80338 19.6428H11.1606C11.4072 19.6428 11.6071 19.8427 11.6071 20.0894C11.6071 20.3357 11.4072 20.5356 11.1606 20.5356ZM12.9465 19.6428H13.8393C14.0857 19.6428 14.2856 19.8427 14.2856 20.0894C14.2856 20.3357 14.0857 20.5356 13.8393 20.5356H12.9465C12.6999 20.5356 12.5 20.3357 12.5 20.0894C12.5 19.8427 12.6999 19.6428 12.9465 19.6428ZM4.01779 4.01779H9.375C9.62158 4.01779 9.82147 4.21768 9.82147 4.46442C9.82147 4.71069 9.62158 4.91058 9.375 4.91058H4.01779C3.77121 4.91058 3.57147 4.71069 3.57147 4.46442C3.57147 4.21768 3.77121 4.01779 4.01779 4.01779ZM4.01779 7.58942H4.91058V7.14279C4.91058 6.89621 5.11047 6.69647 5.35706 6.69647C5.60379 6.69647 5.80338 6.89621 5.80338 7.14279V7.58942H9.375V7.14279C9.375 6.89621 9.57489 6.69647 9.82147 6.69647C10.0679 6.69647 10.2678 6.89621 10.2678 7.14279V7.58942H11.1606C11.9003 7.58942 12.5 8.18878 12.5 8.92853V16.0715C12.5 16.8112 11.9003 17.4106 11.1606 17.4106H4.01779C3.27805 17.4106 2.67838 16.8112 2.67838 16.0715V8.92853C2.67838 8.18878 3.27805 7.58942 4.01779 7.58942ZM1.33926 4.01779H2.23206C2.47879 4.01779 2.67838 4.21768 2.67838 4.46442C2.67838 4.71069 2.47879 4.91058 2.23206 4.91058H1.33926C1.09268 4.91058 0.892792 4.71069 0.892792 4.46442C0.892792 4.21768 1.09268 4.01779 1.33926 4.01779Z"
                      fill="white"
                    />
                    <path
                      d="M13.8393 0H8.03558V0.446472C8.03558 0.692902 7.83569 0.892792 7.58926 0.892792C7.34268 0.892792 7.14279 0.692902 7.14279 0.446472V0H1.33926C0.59967 0 0 0.59967 0 1.33942V2.23221H15.1784V1.33942C15.1784 0.59967 14.579 0 13.8393 0Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Guest Booking
              </Accordion.Header>
              <Accordion.Body className="pt-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/manage-booking"
                      className={`
                      ${styles.link} ${
                        pageActive.includes("/manage-booking") && styles.active
                      } 
                      text-white px-2 py-1`}
                    >
                      Booking Request
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/myguest-booking"
                      className={`${styles.link} ${
                        pageActive.includes("/myguest-booking") && styles.active
                      } text-white px-2 py-1`}
                    >
                      My Booking
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li> */}


          <li className="">
            <NavLink
              to="/manage-driver"
              className={`${styles.link} ${
                pageActive.includes("/manage-driver") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 23"
                  fill="none"
                >
                  <path
                    d="M12.6243 14.309C13.4467 13.6511 14.1047 12.7875 14.4336 11.7595C15.2972 11.3894 15.7084 10.2791 15.7907 9.33333C15.8729 8.55202 15.6673 7.89407 15.2561 7.44174C16.2841 7.11276 16.8598 6.61931 16.8598 5.87912C16.8598 4.15202 13.3645 0.533325 9.00561 0.533325C4.64673 0.533325 1.1514 4.15202 1.1514 5.87912C1.1514 6.57819 1.76822 7.07164 2.75514 7.44174C2.34393 7.89407 2.13832 8.55202 2.22056 9.33333C2.3028 10.2791 2.71402 11.3483 3.57757 11.7595C3.94766 12.7875 4.56449 13.6511 5.38692 14.309C2.26168 15.3371 0 18.2567 0 21.7109C0 22.1632 0.370093 22.5333 0.82243 22.5333H17.1477C17.6 22.5333 17.9701 22.1632 17.9701 21.7109C18.0112 18.2567 15.7495 15.3371 12.6243 14.309ZM4.31776 10.238C4.19439 10.238 3.94766 9.78566 3.90654 9.16884C3.86542 8.5109 4.15327 8.42865 4.23551 8.42865C4.64673 8.38753 4.93458 8.01744 4.93458 7.60622V7.07164C8.38878 8.26417 11.4729 7.60622 13.1178 7.07164V7.60622C13.1178 8.01744 13.4056 8.34641 13.8168 8.42865C13.8991 8.42865 14.1869 8.46977 14.1458 9.16884C14.1047 9.78566 13.8579 10.238 13.7346 10.238C13.3645 10.238 13.0766 10.4847 12.9944 10.8548C12.5421 12.6642 10.8972 13.9389 9.04673 13.9389C7.19626 13.9389 5.5514 12.6642 5.09907 10.8548C5.01682 10.4847 4.68785 10.238 4.31776 10.238ZM6.16822 19.4492L7.36075 20.8885H5.51028C5.63364 20.3539 5.83925 19.8604 6.16822 19.4492ZM12.5832 20.8885H10.7327L11.9252 19.4492C12.2542 19.8604 12.4598 20.3539 12.5832 20.8885ZM9.04673 20.3128L7.44299 18.4212C7.93645 18.1744 8.47103 18.01 9.04673 18.01C9.62243 18.01 10.1981 18.1333 10.6916 18.4212L9.04673 20.3128ZM14.228 20.8885C14.0636 19.6137 13.4056 18.4623 12.4598 17.6399L12.4187 17.5987C11.514 16.8586 10.3215 16.3651 9.04673 16.3651C7.77196 16.3651 6.57944 16.8174 5.67477 17.5987C4.77009 18.3801 5.67477 17.6399 5.63365 17.6399C4.68785 18.4623 4.02991 19.6137 3.86542 20.8885H1.76822C2.17944 17.8866 4.72897 15.5838 7.85421 15.5838H10.2393C13.3645 15.5838 15.914 17.8866 16.3252 20.8885H14.228Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Drivers
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/driver-payout"
              className={`${styles.link} ${
                pageActive.includes("/driver-payout") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 22 21"
                  fill="none"
                >
                  <path
                    d="M13.9831 6.71186C14.4979 6.71186 14.9153 6.2945 14.9153 5.77966C14.9153 5.26482 14.4979 4.84746 13.9831 4.84746C13.4683 4.84746 13.0509 5.26482 13.0509 5.77966C13.0509 6.2945 13.4683 6.71186 13.9831 6.71186Z"
                    fill="white"
                  />
                  <path
                    d="M19.9492 0H19.0885C18.9881 0.402207 18.9935 0.82356 19.1042 1.22305C19.2149 1.62255 19.4272 1.98658 19.7203 2.27971C20.0134 2.57284 20.3775 2.7851 20.777 2.89582C21.1765 3.00654 21.5978 3.01195 22 2.91153V2.05085C21.9995 1.5071 21.7832 0.985779 21.3987 0.60129C21.0142 0.216801 20.4929 0.000552791 19.9492 0Z"
                    fill="white"
                  />
                  <path
                    d="M19.017 11C19.0188 11.1886 19.0428 11.3763 19.0885 11.5593H19.9492C20.4929 11.5588 21.0142 11.3425 21.3987 10.958C21.7832 10.5735 21.9994 10.0522 22 9.50848V8.64779C21.6442 8.55893 21.2727 8.55276 20.9141 8.62975C20.5555 8.70675 20.2193 8.86486 19.9313 9.09195C19.6433 9.31905 19.4112 9.60909 19.2527 9.93984C19.0942 10.2706 19.0135 10.6333 19.017 11Z"
                    fill="white"
                  />
                  <path
                    d="M5.96606 2.05085V2.91153C6.36827 3.01195 6.78962 3.00654 7.18912 2.89582C7.58861 2.7851 7.95264 2.57284 8.24578 2.27971C8.53891 1.98658 8.75116 1.62255 8.86188 1.22305C8.9726 0.82356 8.97802 0.402207 8.8776 0H8.01691C7.47316 0.000552791 6.95184 0.216801 6.56735 0.60129C6.18287 0.985779 5.96662 1.5071 5.96606 2.05085Z"
                    fill="white"
                  />
                  <path
                    d="M17.8983 0.559322C17.9022 0.371666 17.9211 0.184623 17.9549 0H10.0112C10.045 0.184623 10.0639 0.371666 10.0678 0.559322C10.0667 1.49848 9.69315 2.39887 9.02906 3.06296C8.36497 3.72705 7.46459 4.10061 6.52542 4.1017C6.33777 4.09784 6.15072 4.07892 5.9661 4.04509V4.65662L2.38368 7.11107C2.10851 7.29941 1.88343 7.55204 1.72797 7.84703C1.5725 8.14203 1.49134 8.4705 1.49153 8.80395V15.661H1.30508C0.959088 15.6615 0.627387 15.7991 0.38273 16.0437C0.138073 16.2884 0.000434149 16.6201 0 16.9661V19.2034C0.000434149 19.5494 0.138073 19.8811 0.38273 20.1257C0.627387 20.3704 0.959088 20.508 1.30508 20.5085H9.50847C9.85447 20.508 10.1862 20.3704 10.4308 20.1257C10.6755 19.8811 10.8131 19.5494 10.8136 19.2034V16.9661C10.8131 16.6201 10.6755 16.2884 10.4308 16.0437C10.1862 15.7991 9.85447 15.6615 9.50847 15.661H8.91835L10.9515 11.5593H17.9549C17.9211 11.3747 17.9022 11.1877 17.8983 11C17.8994 10.0608 18.273 9.16045 18.937 8.49636C19.6011 7.83227 20.5015 7.45871 21.4407 7.45763C21.6283 7.46148 21.8154 7.48041 22 7.51423V4.04509C21.8154 4.07892 21.6283 4.09784 21.4407 4.1017C20.5015 4.10061 19.6011 3.72705 18.937 3.06296C18.273 2.39887 17.8994 1.49848 17.8983 0.559322ZM10.2208 10.5099L7.67024 15.661H2.61017V8.80351C2.61001 8.65196 2.64688 8.50268 2.71757 8.36864C2.78827 8.23459 2.89064 8.11985 3.01579 8.0344L5.9661 6.01338V10.2219L5.4818 10.5269C5.35625 10.6059 5.26722 10.7315 5.23429 10.8762C5.20137 11.0208 5.22726 11.1726 5.30625 11.2982C5.38627 11.4225 5.51185 11.5106 5.65605 11.5434C5.80024 11.5762 5.95156 11.5512 6.07752 11.4737L9.15961 9.53793C9.29636 9.43664 9.46411 9.38608 9.63406 9.39495C9.80402 9.40381 9.9656 9.47153 10.0911 9.5865C10.2166 9.70147 10.2981 9.85652 10.3218 10.0251C10.3454 10.1936 10.3097 10.3648 10.2208 10.5099ZM10.2542 6.33898C10.1436 6.33898 10.0355 6.30618 9.94349 6.24472C9.85151 6.18326 9.77983 6.09591 9.73749 5.9937C9.69516 5.8915 9.68408 5.77904 9.70566 5.67054C9.72724 5.56204 9.78051 5.46238 9.85874 5.38416C9.93696 5.30594 10.0366 5.25267 10.1451 5.23109C10.2536 5.20951 10.3661 5.22058 10.4683 5.26292C10.5705 5.30525 10.6578 5.37694 10.7193 5.46892C10.7808 5.5609 10.8136 5.66904 10.8136 5.77966C10.8136 5.928 10.7546 6.07027 10.6497 6.17516C10.5448 6.28006 10.4026 6.33898 10.2542 6.33898ZM13.9831 7.83051C13.5774 7.83051 13.1809 7.71023 12.8437 7.48488C12.5064 7.25953 12.2435 6.93923 12.0883 6.56449C11.9331 6.18974 11.8925 5.77739 11.9716 5.37956C12.0507 4.98173 12.2461 4.61631 12.5329 4.32949C12.8197 4.04268 13.1851 3.84735 13.5829 3.76822C13.9808 3.68909 14.3931 3.7297 14.7679 3.88493C15.1426 4.04015 15.4629 4.30301 15.6883 4.64027C15.9136 4.97753 16.0339 5.37404 16.0339 5.77966C16.0333 6.32341 15.8171 6.84473 15.4326 7.22922C15.0481 7.61371 14.5268 7.82996 13.9831 7.83051ZM17.7119 6.33898C17.6012 6.33898 17.4931 6.30618 17.4011 6.24472C17.3091 6.18326 17.2375 6.09591 17.1951 5.9937C17.1528 5.8915 17.1417 5.77904 17.1633 5.67054C17.1849 5.56204 17.2381 5.46238 17.3164 5.38416C17.3946 5.30594 17.4942 5.25267 17.6027 5.23109C17.7112 5.20951 17.8237 5.22058 17.9259 5.26292C18.0281 5.30525 18.1155 5.37694 18.1769 5.46892C18.2384 5.5609 18.2712 5.66904 18.2712 5.77966C18.2712 5.928 18.2123 6.07027 18.1074 6.17516C18.0025 6.28006 17.8602 6.33898 17.7119 6.33898Z"
                    fill="white"
                  />
                </svg>
              </span>
              Driver Payouts
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/earnings"
              className={`${styles.link} ${
                pageActive.includes("/earnings") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <g clip-path="url(#clip0_0_2904)">
                    <path
                      d="M2.10547 12.4975C3.30387 13.0556 4.87566 13.3633 6.53125 13.3633C7.01723 13.3633 7.4959 13.3366 7.9591 13.2846C8.60234 11.0752 10.1973 9.26664 12.268 8.33379C11.9307 7.99949 11.4843 7.69785 10.9377 7.4409C10.6 7.28191 10.2317 7.14312 9.83984 7.02625V8.29297C9.83984 9.35902 8.9723 10.2266 7.90625 10.2266H5.15625C4.0902 10.2266 3.22266 9.35902 3.22266 8.29297V7.02281C2.82391 7.14055 2.44922 7.27976 2.10547 7.44004C0.747656 8.07254 0 8.97059 0 9.96875C0 10.9669 0.747656 11.865 2.10547 12.4975Z"
                      fill="white"
                    />
                    <path
                      d="M2.10547 15.935C3.30387 16.4936 4.87566 16.8008 6.53125 16.8008C6.94547 16.8008 7.3541 16.7815 7.75242 16.7441C7.6841 16.329 7.64844 15.9032 7.64844 15.4688C7.64844 15.1766 7.66434 14.8882 7.69613 14.6047C7.31371 14.6365 6.92398 14.6523 6.53125 14.6523C4.69133 14.6523 2.92617 14.3022 1.56105 13.6662C0.947891 13.3805 0.424961 13.0427 0 12.6586V13.4063C0 14.4044 0.747656 15.3025 2.10547 15.935Z"
                      fill="white"
                    />
                    <path
                      d="M6.53125 18.0898C4.69133 18.0898 2.9266 17.7397 1.56105 17.1037C0.947891 16.818 0.424961 16.4802 0 16.0961V16.8438C0 17.8419 0.747656 18.74 2.10547 19.3725C3.30387 19.9311 4.87566 20.2383 6.53125 20.2383C7.42285 20.2383 8.28867 20.1489 9.08316 19.9788C8.65777 19.3781 8.31445 18.715 8.07125 18.0061C7.56937 18.0615 7.05332 18.0898 6.53125 18.0898Z"
                      fill="white"
                    />
                    <path
                      d="M15.4688 8.9375C11.8675 8.9375 8.9375 11.8675 8.9375 15.4688C8.9375 19.07 11.8675 22 15.4688 22C19.07 22 22 19.07 22 15.4688C22 11.8675 19.07 8.9375 15.4688 8.9375ZM17.3478 16.7763C17.2305 17.4745 16.7463 18.0293 16.1113 18.2581C16.0909 18.5956 15.8114 18.8633 15.4688 18.8633C15.1515 18.8633 14.8884 18.6339 14.8348 18.332C14.5338 18.2808 14.2601 18.1697 13.9133 17.9429C13.6155 17.7478 13.5317 17.3486 13.7268 17.0504C13.9214 16.7527 14.3211 16.6693 14.6188 16.8639C14.9329 17.0698 15.0339 17.0852 15.4645 17.0827C15.8791 17.0801 16.0441 16.7544 16.0763 16.5627C16.1055 16.3904 16.0729 16.1614 15.7536 16.0484C15.2182 15.8593 14.6695 15.6423 14.2807 15.3373C13.8673 15.0129 13.677 14.4564 13.7848 13.8854C13.8956 13.2983 14.293 12.826 14.8305 12.6332C14.8725 12.3178 15.1418 12.0742 15.4688 12.0742C15.8185 12.0742 16.1025 12.3529 16.1123 12.7003C16.2525 12.7519 16.3866 12.8126 16.5101 12.877C16.8816 13.0705 16.9676 13.5642 16.6838 13.8722C16.4836 14.0893 16.1594 14.1418 15.9033 13.9948C15.7023 13.8794 15.4644 13.7853 15.2793 13.8411C15.1079 13.8927 15.0614 14.071 15.0516 14.1243C15.0305 14.2356 15.0606 14.3104 15.0765 14.3228C15.3197 14.5136 15.7722 14.6881 16.1829 14.8329C17.0251 15.1306 17.493 15.9118 17.3478 16.7763Z"
                      fill="white"
                    />
                    <path
                      d="M3.4375 5.45703H4.51172V8.29297C4.51172 8.64875 4.80047 8.9375 5.15625 8.9375H7.90626C8.26204 8.9375 8.55079 8.64875 8.55079 8.29297V5.45703H9.62501C9.86864 5.45703 10.0912 5.31996 10.2008 5.10211C10.3104 4.88469 10.2876 4.62387 10.1423 4.42836L7.0486 0.260391C6.927 0.0966797 6.73536 0 6.53126 0C6.32715 0 6.13551 0.0966797 6.01391 0.260391L2.92016 4.42836C2.77493 4.62387 2.75215 4.88469 2.86172 5.10211C2.97129 5.31996 3.19387 5.45703 3.4375 5.45703Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_2904">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Earnings
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/transaction-history"
              className={`${styles.link} ${
                pageActive.includes("/transaction-history") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_0_3022)">
                    <path
                      d="M3.39466 0C1.81098 0 0.500977 1.31001 0.500977 2.89368V17.1063C0.500977 18.69 1.81098 20 3.39466 20H8.24676C6.57199 18.53 5.50341 16.3834 5.50341 13.9998C5.50341 13.3093 5.60149 12.6411 5.76898 12.0004H5.50538C4.95326 12.0025 4.50396 11.5567 4.50175 11.0046C4.4996 10.4524 4.94544 10.0031 5.49756 10.0009H5.50538H6.5949C7.03512 9.24736 7.59408 8.57246 8.24676 7.99959H5.50538C4.95326 8.00174 4.50396 7.5559 4.50175 7.00379C4.4996 6.45167 4.94544 6.00236 5.49756 6.00016H5.50538H9.50616C9.91118 6.00194 10.2751 6.24787 10.4278 6.62304C11.3756 6.22397 12.4146 6.00213 13.5011 6.00213C13.8398 6.00213 14.1726 6.03071 14.5008 6.07242V6.00016C14.5008 4.45519 13.8887 2.9747 12.7962 1.88223L12.6185 1.71236C11.5261 0.619974 10.0475 4.68612e-05 8.50253 4.68612e-05H3.39466V0ZM13.501 8.00156C10.2001 8.00156 7.50279 10.6989 7.50279 13.9998C7.50279 17.3007 10.2002 19.998 13.501 19.998C16.8019 19.998 19.4993 17.3007 19.4993 13.9998C19.4993 10.699 16.8019 8.00156 13.501 8.00156ZM13.497 11.0046C14.0491 11.0024 14.4985 11.4482 14.5007 12.0003V12.0004V13.004H15.4965C16.0486 13.0008 16.4988 13.4458 16.5021 13.9979V13.9998C16.4999 14.552 16.0506 14.9978 15.4985 14.9956C15.4978 14.9956 15.4972 14.9956 15.4965 14.9956H13.4971C12.9481 14.9934 12.5035 14.5489 12.5013 13.9998V12.0004C12.5035 11.4513 12.948 11.0068 13.4971 11.0046H13.497Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_3022">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Transaction History
            </NavLink>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="1"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10 border-top px-0`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_3628)">
                      <path
                        d="M19.556 8.25992L17.2619 7.69574C17.124 7.26086 16.9466 6.83914 16.7326 6.43574C17.077 5.86238 17.8009 4.65562 17.8009 4.65562C17.9394 4.42504 17.9027 4.12977 17.7128 3.9398L16.0557 2.2827C15.8657 2.09215 15.571 2.05555 15.3398 2.19457L13.5568 3.26289C13.1557 3.05059 12.7363 2.87492 12.3043 2.73816L11.7401 0.444063C11.6748 0.183125 11.4408 0 11.1719 0H8.82812C8.55918 0 8.32457 0.183125 8.25992 0.444023C8.25992 0.444023 7.8691 2.0452 7.69629 2.73758C7.23566 2.88348 6.79051 3.07289 6.36648 3.30406L4.5177 2.19457C4.28652 2.05723 3.99242 2.09273 3.80188 2.2827L2.14477 3.9398C1.9548 4.12977 1.91816 4.42504 2.05664 4.65562L3.19992 6.56508C3.01566 6.92844 2.86117 7.30664 2.73816 7.69402L0.444063 8.25992C0.183125 8.32516 0 8.55918 0 8.82812V11.1719C0 11.4408 0.183125 11.6754 0.444023 11.7401L2.73871 12.3043C2.87777 12.7454 3.05855 13.174 3.27773 13.5854L2.25465 15.2906C2.11617 15.5212 2.15281 15.8164 2.34277 16.0064L3.99988 17.6635C4.1893 17.8529 4.48453 17.8889 4.7157 17.7516C4.7157 17.7516 5.86297 17.0639 6.42488 16.7274C6.83172 16.9443 7.25742 17.1234 7.69633 17.2624L8.25996 19.5559C8.32457 19.8169 8.55918 20 8.82812 20H11.1719C11.4408 20 11.6748 19.8169 11.7401 19.556L12.3037 17.2624C12.7552 17.1194 13.19 16.9345 13.6038 16.7102C14.1811 17.0564 15.3398 17.7516 15.3398 17.7516C15.5704 17.8895 15.8657 17.8541 16.0556 17.6635L17.7127 16.0064C17.9027 15.8164 17.9393 15.5212 17.8009 15.2906L16.7474 13.5356C16.9551 13.1414 17.1274 12.7288 17.2618 12.3043L19.5559 11.7401C19.8169 11.6748 20 11.4408 20 11.1719V8.82812C20 8.55918 19.8169 8.32516 19.556 8.25992ZM10 14.1016C7.73863 14.1016 5.89844 12.2614 5.89844 10C5.89844 7.73863 7.73863 5.89844 10 5.89844C12.2614 5.89844 14.1016 7.73863 14.1016 10C14.1016 12.2614 12.2614 14.1016 10 14.1016Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_3628">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Settings
              </Accordion.Header>
              <Accordion.Body className="pt-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/setting/profile"
                      className={`${styles.link} ${
                        pageActive.includes("/profile") && styles.active
                      } text-white px-2 py-1`}
                    >
                      Manage Profile
                    </NavLink>
                  </li>
                  {/* <li className="">
                    <NavLink
                      to="/setting/Wallet"
                      className={`${styles.link} ${
                        pageActive.includes("/Wallet") && styles.active
                      } text-white px-2 py-1`}
                    >
                      Wallet
                    </NavLink>
                  </li> */}
                  <li className="">
                    <NavLink
                      to="/setting/payment-method"
                      className={`${styles.link} ${
                        pageActive.includes("/payment-method") && styles.active
                      } text-white px-2 py-1`}
                    >
                      Payment Method
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="0"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10 border-top px-0`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="20"
                    viewBox="0 0 15 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.6437 1.99687C14.6437 1.46704 14.4327 0.959164 14.0586 0.584418C13.6839 0.210337 13.176 0 12.6469 0C10.0962 0 4.54754 0 1.99687 0C1.46704 0 0.959164 0.210337 0.584418 0.584418C0.210337 0.959164 0 1.46704 0 1.99687V18.0031C0 18.533 0.210337 19.0408 0.584418 19.4149C0.959164 19.7897 1.46704 20 1.99687 20H12.6469C13.176 20 13.6839 19.7897 14.0586 19.4149C14.4327 19.0408 14.6437 18.533 14.6437 18.0031V1.99687ZM7.41505 16.0748L9.03718 17.2257C9.18295 17.3289 9.36333 17.3695 9.53906 17.3375C9.71478 17.3062 9.87054 17.2057 9.97171 17.0586L11.8514 14.3116C12.0591 14.0081 11.9812 13.594 11.6777 13.3864C11.3748 13.1787 10.9602 13.2566 10.7525 13.5594L9.25484 15.748L8.18518 14.9892C7.88565 14.7768 7.46963 14.8474 7.2573 15.1469C7.04496 15.4465 7.11552 15.8625 7.41505 16.0748ZM3.32279 12.0232H7.32186C7.68862 12.0232 7.98749 11.725 7.98749 11.3575C7.98749 10.9901 7.68862 10.6919 7.32186 10.6919H3.32279C2.95537 10.6919 2.65717 10.9901 2.65717 11.3575C2.65717 11.725 2.95537 12.0232 3.32279 12.0232ZM3.32279 9.36866H11.3023C11.6697 9.36866 11.9679 9.07046 11.9679 8.70303C11.9679 8.33561 11.6697 8.03741 11.3023 8.03741H3.32279C2.95537 8.03741 2.65717 8.33561 2.65717 8.70303C2.65717 9.07046 2.95537 9.36866 3.32279 9.36866ZM3.32279 6.69817H11.3023C11.6697 6.69817 11.9679 6.39997 11.9679 6.03255C11.9679 5.66512 11.6697 5.36693 11.3023 5.36693H3.32279C2.95537 5.36693 2.65717 5.66512 2.65717 6.03255C2.65717 6.39997 2.95537 6.69817 3.32279 6.69817ZM3.32279 4.02769H11.3023C11.6697 4.02769 11.9679 3.72949 11.9679 3.36207C11.9679 2.99464 11.6697 2.69644 11.3023 2.69644H3.32279C2.95537 2.69644 2.65717 2.99464 2.65717 3.36207C2.65717 3.72949 2.95537 4.02769 3.32279 4.02769Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Content
              </Accordion.Header>
              <Accordion.Body className="pt-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/content/terms-condition"
                      className={`${styles.link} ${
                        pageActive.includes("/terms-condition") && styles.active
                      } text-white px-2 py-1`}
                    >
                      Terms and Conditions
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/content/privacy-policy"
                      className={`${styles.link} ${
                        pageActive.includes("/privacy-policy") && styles.active
                      } text-white px-2 py-1`}
                    >
                      Privacy Policy
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/content/about"
                      className={`${styles.link} ${
                        pageActive.includes("/about") && styles.active
                      } text-white px-2 py-1`}
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/content/help-support"
                      className={`${styles.link} ${
                        pageActive.includes("/help-support") && styles.active
                      } text-white px-2 py-1`}
                    >
                      Help & Support
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/content/faq"
                      className={`${styles.link} ${
                        pageActive.includes("/faq") && styles.active
                      } text-white px-2 py-1  `}
                    >
                      FAQ
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          {/* <li className="">
            <NavLink
              to="/login"
              className={`${styles.link} ${
                pageActive.includes("/login") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                >
                  <path d="M6.89893 0H10.4283V9.54422H6.89893V0Z" fill="white" />
                  <path
                    d="M13.8817 4.12244L13.3698 3.79407L11.3992 6.67844L11.8581 7.01489C13.1973 7.99695 13.9969 9.57516 13.9969 11.2368C13.9969 14.1227 11.649 16.4706 8.76312 16.4706C5.87723 16.4706 3.52936 14.1227 3.52936 11.2368C3.52936 9.63544 4.28528 8.09048 5.5513 7.104L5.98694 6.76465L4.00116 3.85373L3.50891 4.22314C1.3118 5.87201 4.44174e-09 8.49393 4.44174e-09 11.2368C-0.000152583 16.0688 3.93112 20 8.76312 20C13.5951 20 17.5262 16.0688 17.5262 11.2367C17.5262 8.42374 16.1638 5.76428 13.8817 4.12244Z"
                    fill="white"
                  />
                </svg>
              </span>
              Logout
            </NavLink>
          </li> */}
        </ul>
      </Accordion>
    </div>
  );
};

export default Sidebar;
